<template>
  <div class="rank-container" :class="isSelect || selectSort ?'over-hidden':''">
    <div class="select-container">
      <div class="area-box" @click="chooseArea">
        <label class="area-title" :class="searchName||isSelect ? 'selected':''">{{searchName || '位置'}}</label>
        <img class="area-img" v-if="!isSelect" src="../../assets/img/down-arow.png">
        <img class="area-img" v-if="isSelect" src="../../assets/img/blue_top.png">
      </div>
      <div class="order-box" @click="selectSorting">
        <img v-if="!sortChoose" class="order-img" src="../../assets/img/order.png">
        <img v-else class="order-img" src="../../assets/img/sorting-active.png">
      </div>
      <div class="filter-warp" v-if="isSelect">
        <div class="filter-container">
          <div class="filter-condition city-box">
            <div class="city-list filter-city">
              <div
                class="city-list-item city"
                :class="searchType=='area' ? 'selected': ''"
                @click.stop="selectArea('area')"
              >位置</div>
              <div
                class="city-list-item city"
                :class="searchType=='line' ? 'selected': ''"
                @click.stop="selectArea('line')"
              >地铁</div>
            </div>
            <!-- 第二级别 -->
            <div class="city-list filter-district">
              <!-- <div
                class="city-list-item district"
                :class="lineType==='line9999'?'selected':''"
                @click.stop="selectStanding('line','9999','')"
              >不限</div> -->
              <div
                v-for="(districtItem,districtIndex) in districtList"
                :key="districtIndex"
                class="city-list-item district"
                :class="lineType===('line'+districtIndex) ? 'selected' : ''"
                @click.stop="selectStanding('district',districtIndex,districtItem)"
              >{{districtItem.name}}</div>
            </div>
            <div class="city-list filter-district">
              <div
                class="city-list-item district"
                :class="standType===('stand9999') ? 'selected' : ''"
                @click.stop="selectDistrict('area','9999')"
                v-if="standingList.length>0"
              >不限
              <img class="select-img" v-if="standType===('stand9999')" src="../../assets/img/rectangle.png">              
              </div>
              <div
                class="city-list-item district"
                :class="standType===('stand'+areaIndex) ? 'selected' : ''"
                v-for="(area,areaIndex) in standingList"
                :key="areaIndex"
                @click.stop="selectDistrict('area',areaIndex,area)"
              >
              <label>{{area.name}}</label>
              <img class="select-img" v-if="standType===('stand'+areaIndex)" src="../../assets/img/rectangle.png">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-mask" v-if="isSelect || selectSort" @click="hideSearch">
      <div class="sorting-box" v-if="selectSort">
      <div
        class="sort-item"
        v-for="(item,index) in sortingList"
        :key="index"
        @click="checkedSort(index)"
      >
        <label :class="item.checked? 'blue-color': ''">{{item.label}}</label>
        <img class="sort-img" :src="item.src" v-if="item.checked">
      </div>
    </div>
    </div>
    <van-pull-refresh v-model="isRefresh" :animation-duration='100' @refresh="onRefresh">
    <div v-if="villageList.length>0">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="暂无更多商圈了"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="onLoad"
          class="village-content-wrapper"
        >
        <div
          class="village-content"
          v-for="(item,index) in villageList"
          :key="index"
          @click.stop="goDetail(item)"
        >
          <div class="content-header">
            <div class="content-header-left">
              <label class="title">{{item.zoneName}}</label>
              <div class="grade-box">
                <img class="header-img" src="../../assets/img/score.png">
                <label class="grade-num">{{item.score}}分</label>
              </div>
            </div>
          </div>
          <div class="content-info">
            <div class="rank-item">
              <div class="rank-title">挂牌量</div>
              <div class="rank-number">{{item.houseNum}}</div>
            </div>
            <div class="rank-item">
              <div class="rank-title">月租金</div>
              <div class="rank-number">{{item.unitRentPrice}}元/㎡</div>
            </div>
            <div class="rank-item">
              <div class="rank-title">租金环比</div>
              <div class="rank-number" v-if="item.ratio">{{item.ratio}}</div>
              <div class="rank-number" v-else>-</div>
            </div>
            <div class="rank-item">
              <div class="rank-title">中介数量</div>
              <div class="rank-number">{{item.agencyNum}}</div>
            </div>
          </div>
          <div class="rankimg-box">
            <img
              v-if="index==0 && sorting=='DESC'"
              class="rank-img"
              src="../../assets/img/first.png"
            >
            <img
              v-if="index==1 && sorting=='DESC'"
              class="rank-img"
              src="../../assets/img/second.png"
            >
            <img
              v-if="index==2 && sorting=='DESC'"
              class="rank-img"
              src="../../assets/img/third.png"
            >
          </div>
        </div>
        </van-list>
    </div>
    <div v-else>
      <div class="nodata">
        <label class="info">没有搜到相关商圈</label>
      </div>
    </div>
    <div class="footer" v-if="allLoaded && villageList.length>0">
      <label>暂无更多商圈了</label>
    </div>
    </van-pull-refresh>
  </div>
</template>

<script>
let timestampStart, timestampEnd;
import { List,PullRefresh } from 'vant';
export default {
  name: "rank",
  components: {
    'van-list':List,
    'van-pull-refresh':PullRefresh 
  },
  data() {
    return {
      districtList: [],
      standingList: [],
      sortingList: [
        {
          label: "分数从高到低",
          src: require("../../assets/img/rectangle.png"),
          checked: false
        },
        {
          label: "分数从低到高",
          src: require("../../assets/img/rectangle.png"),
          checked: false
        }
      ],
      villageList: [],
      loadMore: false,
      noData: false,
      isSelect: false,
      pageNum: 1,
      pageSize: 10,
      allLoaded: false,
      loading: false,
      finished:false,
      isRefresh:false,
      error:false,
      selectSort: false,
      sortChoose: false,
      standType: "",
      lineType: "",
      searchType: "area",
      sorting: "DESC",
      cityId: "",
      districtId: "",
      zoneId: "",
      searchIndex: "",
      areaIndex: "",
      subwayLineId: "",
      subwaySiteId: "",
      searchName: "",
      firstInfo: {}
    };
  },
  created() {
    if (this._uid==2) {
      localStorage.removeItem('screenRank');
    }
    timestampStart = new Date().getTime();
    // this.$parent.addBuried({
    //   source:'1',
    //   eventType: '曝光事件',
    //   eventContent: '商圈排名'
    // });
    let options = this.$route.query;
    this.cityId = options.cityId;
    this.isMiniProgram(res => {
        if (res) {
          this.getBuessinessList();
        }else{
          let screenData = JSON.parse(localStorage.getItem('screenRank'));
          if (screenData) {
            this.standType= screenData.type.standType;
            this.searchType= screenData.type.searchType;
            this.lineType= screenData.type.lineType;
            this.searchName= screenData.type.searchName;
            if (this.searchType=='line') {
              this.getLineList();              
              this.getStandingList(screenData.data.subwayLineId);
            }else{
              this.getAreaList();
              this.getCircleList(screenData.data.districtId);
            }
            this.getBuessinessList(false,screenData.data);
          }else{
            this.getBuessinessList();
          }
        }
      })
    this.getAreaList();
  },
  mounted() {},
  methods: {
    // 位置、地铁切换
    selectArea(info) {
      this.searchType = info;
      this.searchName = "";
      this.standType = "";
      this.lineType = "";
      this.standingList = [];
      if (info == "area") {
        this.subwayLineId="";
        this.subwaySiteId="";
        this.getAreaList();
      } else {
        this.districtId = "";
        this.zoneId = "";
        this.getLineList();
      }
    },
    // 选择排序
    selectSorting() {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "排序方式"
      });
      this.isSelect = false;
      this.selectSort = !this.selectSort;
    },
    checkedSort(index) {
      for (let i = 0; i < this.sortingList.length; i++) {
        this.sortingList[i].checked = false;
      }
      this.sortingList[index].checked = !this.sortingList[index].checked;
      this.selectSort = false;
      this.sorting = index == 1 ? "ASC" : "DESC";
      this.sortChoose = true;
      this.getBuessinessList();
    },
    // 选择区域
    chooseArea() {
      this.addBuried({
        source:'1',
        eventType: '点击事件',
        eventContent: '区域筛选'
      });
      this.selectSort = false;
      this.isSelect = !this.isSelect;
    },
    // 地铁线对应的站
    selectStanding(name, index, info) {
      this.standType = "";
      this.firstInfo = info;
      this.lineType = "line" + index;
      this.areaIndex = index;
      if (name == "line") {
        this.isSelect = false;
        this.searchName = "";
        this.districtId = "";
        this.subwayLineId = "";
        this.subwaySiteId = "";
        this.zoneId = "";
        this.pageNum = 1;
        this.getBuessinessList();
      } else {
        if (this.searchType == "area") {
          this.districtId = info.value;
          this.getCircleList(info.value);
        } else {
          this.subwayLineId = info.value;
          this.getStandingList(info.value);
        }
        this.searchName = info.name;
      }
    },
    selectDistrict(name, index, item) {
      if (index != "9999") {
        if (this.searchType == "area") {
          this.zoneId = item.value;
        } else {
          this.subwaySiteId = item.value;
        }
        this.searchName = item.name;
      } else {
        this.subwaySiteId = "";
        this.zoneId = "";
        this.searchName = this.firstInfo.name;
      }
      this.standType = "stand" + index;
      this.isSelect = false;
      this.pageNum = 1;
      let data = {
        cityId: this.cityId, // 城市ID
        districtId: this.districtId, // 区域ID
        zoneId: this.zoneId, // 	商圈ID
        subwayLineId: this.subwayLineId, // 地铁线路ID
        subwaySiteId: this.subwaySiteId, // 地铁站点ID
        sorting: this.sorting, // 排序
        pageNum:this.pageNum,
        pageSize:this.pageSize
      };
      let type = {
        standType: this.standType,
        lineType: this.lineType,
        searchType: this.searchType,
        searchName:this.searchName
      }
      this.isMiniProgram(res => {
        if (!res) {
          localStorage.setItem('screenRank',JSON.stringify({
            data:data,
            type:type
          }))
        }
      })
      this.getBuessinessList();
      this.searchIndex = index;
    },
    hideSearch() {
      this.isSelect = false;
      this.selectSort = false;
    },
    goDetail(e) {
       this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.navigateTo({
            url:
              "/pages/area_detail/index?zoneId=" +
              e.zoneId +
              "&latitude=" +
              e.latitude +
              "&longitude=" +
              e.longitude +
              "&cityId=" +
              this.cityId
          });
        } else {
          this.$router.push({
            path: "/area_detail",
            query: {
              cityId: this.cityId,
              zoneId: e.zoneId,
              latitude: e.latitude,
              longitude: e.longitude
            }
          });
        }
      });
    },
    // 获取区域数据
    getAreaList() {
      this.$axios
        .post("api/xz/area/list/", {
          cityId: this.cityId
        })
        .then(res => {
          if (res.success) {
            let list = res.result;
            this.districtList = list;
          } else {
          }
        })
        .catch(err => {});
    },
    // 获取区域下面对应的商圈
    getCircleList(areaId) {
      this.$axios
        .post("api/xz/zone/infolist/", {
          areaId: areaId
        })
        .then(res => {
          if (res.success) {
            let list = res.result;
            this.standingList = list;
          } else {
          }
        })
        .catch(err => {});
    },
    // 获取地铁线
    getLineList(loadMore) {
      this.$axios
        .post("api/xz/subwayline/list/", {
          cityId: this.cityId
        })
        .then(res => {
          if (res.success) {
            let list = res.result;
            this.districtList = list;
          } else {
          }
        })
        .catch(err => {});
    },
    // 获取地铁线对应的地铁站
    getStandingList(lineId) {
      this.$axios
        .post("api/xz/subwaysite/list/", {
          lineId: lineId
        })
        .then(res => {
          if (res.success) {
            let list = res.result;
            this.standingList = list;
          } else {
          }
        })
        .catch(err => {});
    },
    onLoad(){
      this.getBuessinessList(true)
    },
    onRefresh(){
      this.pageNum = 1;
      this.getBuessinessList()
    },
    // 获取商圈排名
    getBuessinessList(loadMore,screenData) {
      let { pageNum, pageSize } = this;
      pageNum = loadMore ? pageNum + 1 : pageNum;
      let data = {
        cityId: this.cityId, // 城市ID
        districtId: this.districtId, // 区域ID
        zoneId: this.zoneId, // 	商圈ID
        subwayLineId: this.subwayLineId, // 地铁线路ID
        subwaySiteId: this.subwaySiteId, // 地铁站点ID
        sorting: this.sorting, // 排序
        pageNum,
        pageSize
      };
      this.$axios
        .post("api/xz/zone/lists/", screenData?screenData:data)
        .then(res => {
          if (res.success) {
            let list = res.result,
              len = list.length;
            this.villageList = loadMore ? this.villageList.concat(list) : list;
            for (let i = 0; i < this.villageList.length; i++) {
              if (
                this.villageList[i].ratio &&
                typeof this.villageList[i].ratio == "number"
              ) {
                this.villageList[i].ratio =
                  Math.abs(
                    parseInt(this.villageList[i].ratio * 100 * 100) / 100
                  ) + "%";
              }
            }
            if (len < pageSize) {
              // this.allLoaded = true;
              this.finished = true;
            }
            this.pageNum = pageNum;
          } else {
            this.error = true;
          }
          this.loading = false;
          this.isRefresh = false;
        })
        .catch(err => {});
    }
  },
  destroyed() {
    timestampEnd = new Date().getTime();
    let residenceTime = timestampEnd - timestampStart;
    // this.$parent.addBuried({
    //   source:'1',
    //   eventType: '页面停留时长',
    //   eventContent: '商圈详情停留时长'+residenceTime/1000+'s'
    // });
  }
};
</script>
<style lang="less">
.rank-container {
  width: 750px;
  // height: 100%;
  min-height: 100vh;
  background: #f7f7f7;
  .filter-mask {
    position: fixed;
    top: 0;
    width: 100%;
    bottom: 0;
    background: rgba(0, 0, 0, 0.32);
    z-index: 1;
  }
  .select-container {
    position: fixed;
    top: 0;
    z-index: 99;
    width: 100%;
    height: 88px;
    background: rgba(255, 255, 255, 1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    // position: relative;
    .area-box {
      flex: 3;
      text-align: center;
      height: 42px;
      line-height: 42px;
      display: flex;
      justify-content: center;
      align-items: center;
      .area-title {
        font-size: 30px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(35, 44, 55, 1);
      }
      .selected {
        color: #4169e1;
        border: none;
      }
      .area-img {
        width: 12px;
        height: 8px;
        margin-left: 14px;
      }
    }
    .order-box {
      width: 182px;
      text-align: center;
      border-left: 4px solid #efefef;
      .order-img {
        width: 30px;
        height: 28px;
      }
    }
  }
  .filter-warp {
    position: absolute;
    top: 88px;
    left: 0;
    z-index: 2;
    background: #fff;
    width: 100%;
    .filter-container {
      max-height: 828px;
      overflow-y: scroll;
      background: #f3f7fb;
      font-family: PingFangSC-Regular;
      font-size: 30px;
      font-weight: 400;
      color: rgba(35, 44, 55, 1);
      line-height: 42px;
      border-top: 2px solid #eee;
      .city-box {
        display: flex;
        display: -webkit-flex;
        height: 100%;
        .filter-area {
          height: 828px;
          width: 33%;
          overflow-y: scroll;
          text-align: left;
          background: #ffffff;
          padding-left: 20px;
        }
        .city {
          overflow-y: scroll;
          text-align: center;
        }
        .district {
          padding: 0 20px;
        }
        .selected {
          color: #4169e1;
          border: none;
        }
      }
      .city-list {
        background: rgba(247, 247, 247, 1);
      }
      .filter-city {
        width: 183px;
        overflow-y: scroll;
      }
      .filter-district {
        height: 828px;
        flex: 1;
        overflow-y: scroll;
        text-align: left;
        background: #ffffff;
      }
    }
    .city-box .city,
    .city-box .district,
    .city-box .area {
      height: 104px;
      line-height: 104px;
      color: #232C37;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:0 24px;
      .select-img{
        width:28px;
        height: 20px;
      }
    }
    .selected {
      background: #fff;
      border: none;
    }
  }

  .selected {
    color: #4169e1;
    border: none;
  }
  .van-pull-refresh__track{
    min-height: 90vh;    
  }
  .village-content-wrapper {
    background: #f7f7f7;
    width: 718px;
    // min-height: 90vh;
    height: 100%;
    margin-top: 88px;
    padding: 16px;
    .village-content {
      background: #fff;
      padding: 24px;
      margin-bottom: 18px;
      position: relative;
      .rankimg-box {
        position: absolute;
        right: 18px;
        top: -8px;
        .rank-img {
          width: 78px;
          height: 38px;
        }
      }
      .content-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .content-header-left {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .grade-box {
            width: 100px;
            height: 36px;
            background: rgba(245, 103, 11, 1);
            border-radius: 6px;
            box-sizing: border-box;
            line-height: 36px;
            align-items: center;
            .header-img {
              margin: 0px 6px 0 10px;
              width: 16px;
              height: 24px;
            }
            .grade-num {
              font-size: 28px;
              font-weight: 600;
              color: rgba(255, 255, 255, 1);
            }
          }
          .title {
            font-size: 32px;
            font-weight: 600;
            color: rgba(35, 44, 55, 1);
            margin-right: 10px;
          }
        }
      }
      .content-info {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin: 38px 0 24px;
        .info-img {
          width: 24px;
          height: 26px;
        }
        .rank-item {
          text-align: center;
          .rank-title {
            font-size: 26px;
            font-weight: 400;
            color: rgba(137, 147, 159, 1);
            line-height: 36px;
            margin-bottom: 16px;
          }
          .rank-number {
            font-size: 32px;
            font-weight: 400;
            color: rgba(35, 44, 55, 1);
            line-height: 44px;
          }
        }
      }
    }
  }
  .sorting-box {
    width: 100%;
    // height: 186px;
    position: absolute;
    top: 88px;
    left: 0;
    z-index: 2;
    background: #fff;
    width: 100%;
    border-top: 2px solid #efefef;
    .sort-item {
      padding: 32px 30px 24px;
      font-size: 30px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(35, 44, 55, 1);
      box-sizing: border-box;
      .blue-color {
        color: #4169e1;
      }
    }
    .sort-img {
      width: 20px;
      height: 20px;
      float: right;
    }
  }
  .footer {
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #f7f7f7;
    padding-bottom: 34px;
    color: rgba(189, 195, 206, 1);
    font-size: 26px;
  }
}
.over-hidden {
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  z-index: 0;
}
.nodata {
  width: 100%;
  height: 100%;
  background: #f7f7f7;
  margin-top: 108px;
  padding-top: 16px;
  text-align: center;
  .info {
    font-size: 28px;
    color: #6f7884;
    line-height: 88px;
    // margin-top:110px;
    display: block;
    background: #fff;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/business_rank/index.vue